import { Badge } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { Link } from "@src/components/ui-kit";
import { currency } from "@src/utils/formatters";
import { kebabCase } from "lodash";
import { observer } from "mobx-react-lite";
import React from "react";
import { type FinishProjectSummary, useSummaryContext } from "../models";

type TOverInvoicedItem =
  | FinishProjectSummary["overinvoiced_our_work_budget_items"][0]
  | FinishProjectSummary["overinvoiced_expense_budget_items"][0];

type TUnderInvoicedItem =
  | FinishProjectSummary["underinvoiced_our_work_budget_items"][0]
  | FinishProjectSummary["underinvoiced_expense_budget_items"][0];

type CreditItemProps =
  | { credit: "over"; item: TOverInvoicedItem }
  | { credit: "under"; item: TUnderInvoicedItem };

export const CreditItem = observer(function CreditItem({
  item,
  credit,
}: CreditItemProps) {
  const summary = useSummaryContext();

  return (
    <div className="py-8 border-b last:border-b-0 border-sky">
      <div className="flex items-center mb-4 space-x-4">
        <Link
          href={{
            pathname: "/projects/detail",
            query: { id: summary.id },
            hash: kebabCase(item.title),
          }}
        >
          {item.title}
        </Link>
        <Badge lineHeight="normal" size="sm">
          {credit === "over" ? t`Overinvoiced` : t`Underinvoiced`}
        </Badge>
      </div>
      <p>
        {credit === "over" && "over_invoiced" in item.stats ? (
          <React.Fragment>
            <Trans>Exceeding credit:</Trans>
            <span className="ml-2">
              {currency.formatByWorkspace(item.stats.over_invoiced)}
            </span>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Trans>Missing credit:</Trans>
            <span className="ml-2">
              {currency.formatByWorkspace(
                item.stats.total_budget - item.stats.credit,
              )}
            </span>
          </React.Fragment>
        )}
      </p>
    </div>
  );
});
